import React from 'react';
import Hero from '../components/Hero';
import CustomerLogos from '../components/CustomerLogos';
import Problem from '../components/Problem';
import Solution from '../components/Solution';
import Features from '../components/Features';
import Testimonials from '../components/Testimonials';
import HowItWorks from '../components/HowItWorks';
import TrustSafety from '../components/TrustSafety';
import CTA from '../components/CTA';
import Footer from '../components/Footer';

export default function HomePage() {
  return (
    <>
      <Hero />
      <CustomerLogos />
      <Problem />
      <Solution />
      <Features />
      <Testimonials />
      <HowItWorks />
      <TrustSafety />
      <CTA />
      <Footer />
    </>
  );
}
